var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
import { Mutations, Actions } from '@/store/enums/pscm/reporting/reportingEnums';
import moment from 'moment';
let PscmReportingModule = class PscmReportingModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.reportingList = {
            data: []
        };
        this.chartData = {
            crf: {
                info: {},
                chart: []
            },
            contract: {
                info: {},
                chart: []
            }
        };
        this.listNotFound = {
            type: null,
            subType: null
        };
        this.filterForm = {
            CRFNo: [],
            CRFStatus: [],
            ContractNo: [],
            ContractStatus: [],
            createdDate: [
                moment().subtract(6, 'months').format('DD MMM YYYY'),
                moment().format('DD MMM YYYY')
            ],
            contractCreatedDate: null
        };
        this.isCreatedDateChange = false;
        this.filterTips = [];
        this.lookupOptions = {
            CRFNo: [],
            crfStatus: [],
            ContractNo: [],
            ContractStatus: []
        };
    }
    get getChartDataPscmReporting() {
        return this.chartData;
    }
    get getIsCreatedDateChange() {
        return this.isCreatedDateChange;
    }
    get getFilterTipsPscmReporting() {
        return this.filterTips;
    }
    get getFilterFormPscmReporting() {
        return this.filterForm;
    }
    get getLookupOptionsFilterPscmReport() {
        return this.lookupOptions;
    }
    get getListNotFoundPscmReporting() {
        return this.listNotFound;
    }
    get getReportingList() {
        return this.reportingList;
    }
    [_a = Mutations.SET_CHART](content) {
        this.chartData.crf.info = content.crf.info;
        this.chartData.crf.chart = content.crf.chart;
        this.chartData.contract.info = content.contract.info;
        this.chartData.contract.chart = content.contract.chart;
    }
    [_b = Mutations.SET_IS_CREATED_DATE_CHANGE](val) {
        this.isCreatedDateChange = val;
    }
    [_c = Mutations.SET_DELETE_FILTER_TIPS](obj) {
        const index = this.filterTips.findIndex((e) => {
            return e.keyName == obj;
        });
        this.filterTips.splice(index, 1);
        if (obj != 'createdDate' && obj != 'contractCreatedDate')
            this.filterForm[obj] = [];
        else
            this.filterForm[obj] = null;
    }
    [_d = Mutations.SET_FILTER_TIPS](data) {
        this.filterTips = data;
    }
    [_e = Mutations.SET_RESET_FORM_FILTER](obj) {
        if (obj != 'createdDate' && obj != 'contractCreatedDate')
            this.filterForm[obj] = [];
        else
            this.filterForm[obj] = null;
    }
    [_f = Mutations.SET_MANUAL_FORM_FILTER](obj) {
        this.filterForm[obj.name] = obj.val;
    }
    [_g = Mutations.SET_RESET_ALL_FILTER](obj) {
        if (obj != 'createdDate' && obj != 'contractCreatedDate')
            this.filterForm[obj] = [];
        else if (obj == 'createdDate') {
            this.filterForm[obj] = [
                moment().subtract(6, 'months').format('DD MMM YYYY'),
                moment().format('DD MMM YYYY')
            ];
        }
        else
            this.filterForm[obj] = null;
        this.isCreatedDateChange = false;
    }
    [_h = Mutations.SET_LOOKUP_FILTER]({ data, obj }) {
        this.lookupOptions[obj] = data;
    }
    [_j = Mutations.SET_NOT_FOUND]({ type, subType }) {
        this.listNotFound.type = type;
        this.listNotFound.subType = subType;
    }
    [_k = Mutations.SET_LIST](data) {
        this.reportingList = data;
    }
    [_l = Actions.GET_LOOKUP_OPTIONS](obj) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/contractreport/lookup?ver=v1`;
            const params = {
                lookupKey: obj.lookupKey,
                search: obj.search,
                length: 10
            };
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, params)
                    .then((response) => {
                    const axiosResponse = response.data.result.content;
                    this.context.commit(Mutations.SET_LOOKUP_FILTER, {
                        data: axiosResponse,
                        obj: obj.lookupKey
                    });
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    [_m = Actions.GET_LIST](params) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/contractreport/list?ver=v1`;
            const parameter = {
                pagingParameter: {
                    pageNumber: params.page,
                    pageSize: params.pageSize,
                    orderColumn: params.orderColumn,
                    orderDir: params.orderDir
                },
                pageFilter: params.pageFilter,
                globalSearch: params.search
            };
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, parameter)
                    .then((response) => {
                    const axiosResponse = response.data.result.content;
                    this.context.commit(Mutations.SET_LIST, axiosResponse);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    [_o = Actions.GET_DOWNLOAD_EXCEL](params) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/contractreport/export/excel?ver=v1`;
            const parameter = {
                pagingParameter: {
                    pageNumber: params.page,
                    pageSize: params.pageSize,
                    orderColumn: params.orderColumn,
                    orderDir: params.orderDir
                },
                globalSearch: params.search,
                pageFilter: params.pageFilter
            };
            return yield new Promise((resolve, reject) => {
                ApiService.postBlobFile(apiUrl, parameter)
                    .then((response) => {
                    const fileName = response.headers['content-disposition']
                        .split('; ')[1]
                        .split('=')[1]
                        .split('"')[1];
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    resolve();
                })
                    .catch((error) => {
                    this.context.commit('setErrorHandlerMigo', error.response.data);
                    reject(error);
                });
            });
        });
    }
    [_p = Actions.GET_CHART](params) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/contractreport/chart?ver=v1`;
            const parameter = {
                globalSearch: params.search,
                pageFilter: params.pageFilter
            };
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, parameter)
                    .then((response) => {
                    if (!response.data.result.isError) {
                        const data = response.data.result.content;
                        this.context.commit(Mutations.SET_CHART, data);
                        resolve();
                    }
                    else {
                        resolve();
                    }
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PscmReportingModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], PscmReportingModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PscmReportingModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PscmReportingModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PscmReportingModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PscmReportingModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PscmReportingModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PscmReportingModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PscmReportingModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PscmReportingModule.prototype, _k, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], PscmReportingModule.prototype, _l, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], PscmReportingModule.prototype, _m, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], PscmReportingModule.prototype, _o, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], PscmReportingModule.prototype, _p, null);
PscmReportingModule = __decorate([
    Module
], PscmReportingModule);
export default PscmReportingModule;
